var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStart3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 206.534,
    height: 338.922,
    viewBox: "0 0 206.534 338.922",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4096",
    "data-name": "Group 4096",
    transform: "translate(-2756.508 -10884.578)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6296",
    "data-name": "Path 6296",
    d: "M1033.712,364.75c0,5.15,3,103.85,3,103.85l-42-.22-7.34-43.86-1.94,43.86h-40.36l4.38-108.33Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6297",
    "data-name": "Path 6297",
    d: "M909.892,323.88l-21.46-32,15.92-12.94,26.93,25s11.59-65,23-68.92l-.89,100.8h0A34.49,34.49,0,0,1,909.892,323.88Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6298",
    "data-name": "Path 6298",
    d: "M865.952,173.19l4.56,62.3,74.78,143.34,43.23-25.03-73.69-140.09Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3258",
    "data-name": "Group 3258",
    transform: "translate(1891.14 10754.9)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6299",
    "data-name": "Path 6299",
    d: "M915.562,214a4.39,4.39,0,0,1-6.023,1.506c-.126-.076-.249-.158-.367-.246a11.11,11.11,0,0,1-17.77,11.3,13,13,0,0,1-20.92,8.5l-4.53-61.84Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6300",
    "data-name": "Path 6300",
    d: "M867.782,198.25s10.14,6.36,18.19-8.46l-20-16.6Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6301",
    "data-name": "Path 6301",
    d: "M961.772,367.12c-.13.07-16-31.31-35.51-70.06s-35.17-70.25-35-70.31,16,31.3,35.51,70.07S961.9,367.06,961.772,367.12Z",
    transform: "translate(1891.14 10754.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6302",
    "data-name": "Path 6302",
    d: "M979.742,356.37c-.13.06-16-31.31-35.5-70.07s-35.17-70.24-35.05-70.3,16,31.31,35.51,70.08S979.872,356.3,979.742,356.37Z",
    transform: "translate(1891.14 10754.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6303",
    "data-name": "Path 6303",
    d: "M891.822,256.65l-9.7,3.88-2.07,7.81,3.34,13,7.83,8.31,5.29-4.37.33-8,.64-4.47s4.78-1.5,4.9-2.23-.59-3.19-1.32-3.3-5.75,1.75-5.75,1.75,5.93-4.7,5.77-5.46-.81-2.68-2-2.9-10.76,4.3-10.76,4.3l-1.56,3.55-1.36-5.67S893.932,260.52,891.822,256.65Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6304",
    "data-name": "Path 6304",
    d: "M893.042,275a2.419,2.419,0,0,1-.33-1,5.33,5.33,0,0,1,1.67-4.5c.48-.42.84-.57.88-.52a7.471,7.471,0,0,0-2.22,6Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6305",
    "data-name": "Path 6305",
    d: "M888.432,273.28a19.289,19.289,0,0,0,.39-2.54,10.737,10.737,0,0,1,.49-2.81,4.134,4.134,0,0,1,.89-1.51,4.421,4.421,0,0,1,1.58-1c2.32-.84,4.41-1.52,5.94-2a13.483,13.483,0,0,1,2.51-.69,13.863,13.863,0,0,1-2.39,1c-1.49.57-3.59,1.32-5.87,2.14a3.925,3.925,0,0,0-1.42.88,3.691,3.691,0,0,0-.81,1.32,11.947,11.947,0,0,0-.57,2.69A5.135,5.135,0,0,1,888.432,273.28Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6306",
    "data-name": "Path 6306",
    d: "M886.212,271.53c-.14,0-.11-.88.06-1.91s.42-1.86.56-1.83a4,4,0,0,1-.07,1.91C886.592,270.73,886.342,271.55,886.212,271.53Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6307",
    "data-name": "Path 6307",
    d: "M1017.352,216.37l-8.5-2.89-31.78,7.29-2.82,2.34-16.82,155.72c7.22,7.45,30,8.93,42.93,6.73Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#fff",
    stroke: "#1e1a1a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6308",
    "data-name": "Path 6308",
    d: "M1017.942,216.67l-4.09-2s-9,39.64-9,65.83-5.66,121.11-5.66,121.11l42.87-1.11V295.59Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6309",
    "data-name": "Path 6309",
    d: "M957.432,403.14l-16.25-4.75,5.67-76.75L945.782,266l8.5-31,20.16-12.46S958.542,393.9,957.432,403.14Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6310",
    "data-name": "Path 6310",
    d: "M1012.012,168.969l.94-13.159-1.91-1.47a44.7,44.7,0,0,0-44.91-5.64s-2.21,29.52-2.08,42.39,13,14.87,13,14.87v13.92a15.651,15.651,0,0,0,14.26,15.65l.25.02a15.65,15.65,0,0,0,16.73-14.49l2.8-39.195c1.329.436,8.6,1.435,8.851-6.555C1020.18,167.852,1014.02,168.536,1012.012,168.969Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6311",
    "data-name": "Path 6311",
    d: "M977.082,205.77a30,30,0,0,0,16.77-4.77s-4,9.25-16.8,8.09Z",
    transform: "translate(1891.14 10754.9)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6312",
    "data-name": "Path 6312",
    d: "M1013.652,178.51a3.372,3.372,0,0,0,.4.24,1.5,1.5,0,0,0,1.15.06c.94-.31,1.77-1.76,1.86-3.34a5.079,5.079,0,0,0-.36-2.21,1.78,1.78,0,0,0-1.11-1.21.76.76,0,0,0-.92.39c-.13.24-.08.42-.12.43s-.19-.15-.11-.51a1,1,0,0,1,.37-.54,1.1,1.1,0,0,1,.85-.2,2.148,2.148,0,0,1,1.59,1.38,5.349,5.349,0,0,1,.45,2.47c-.11,1.77-1.07,3.4-2.36,3.73a1.627,1.627,0,0,1-1.39-.28C1013.652,178.73,1013.652,178.53,1013.652,178.51Z",
    transform: "translate(1891.14 10754.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6313",
    "data-name": "Path 6313",
    d: "M970.362,168.49a1.831,1.831,0,0,0,1.77,1.85,1.769,1.769,0,0,0,1.9-1.632l0-.028a1.83,1.83,0,0,0-1.77-1.85,1.77,1.77,0,0,0-1.9,1.632Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6314",
    "data-name": "Path 6314",
    d: "M968.582,166.79c.23.24,1.62-.79,3.6-.78s3.42,1,3.64.75-.13-.54-.76-1a5,5,0,0,0-2.92-.9,4.9,4.9,0,0,0-2.86.92C968.652,166.25,968.472,166.68,968.582,166.79Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6315",
    "data-name": "Path 6315",
    d: "M989.792,169.32a1.831,1.831,0,0,0,1.77,1.85,1.759,1.759,0,0,0,1.9-1.611l0-.039a1.85,1.85,0,0,0-1.77-1.86,1.77,1.77,0,0,0-1.9,1.632Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6316",
    "data-name": "Path 6316",
    d: "M988.012,167.16c.23.24,1.62-.79,3.6-.79s3.42,1,3.64.76-.13-.54-.76-1a5,5,0,0,0-2.92-.9,4.9,4.9,0,0,0-2.86.92C988.112,166.62,987.9,167.05,988.012,167.16Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6317",
    "data-name": "Path 6317",
    d: "M980.842,181.82a13.022,13.022,0,0,0-3.21-.58c-.51-.05-1-.15-1.07-.5a2.56,2.56,0,0,1,.33-1.49c.48-1.22,1-2.51,1.5-3.85,2.07-5.47,3.57-10,3.35-10.05s-2.08,4.29-4.15,9.76c-.5,1.35-1,2.64-1.43,3.87a3.005,3.005,0,0,0-.27,2,1.273,1.273,0,0,0,.83.73,3.206,3.206,0,0,0,.86.12A13.123,13.123,0,0,0,980.842,181.82Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6318",
    "data-name": "Path 6318",
    d: "M987.5,159.41c.19.54,2.17.29,4.49.57s4.19.91,4.5.43c.14-.24-.19-.74-1-1.26a7.841,7.841,0,0,0-6.84-.76C987.842,158.74,987.422,159.16,987.5,159.41Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6319",
    "data-name": "Path 6319",
    d: "M969.312,161.07c.34.45,1.71,0,3.34,0s3,.3,3.35-.17c.14-.22-.08-.67-.69-1.1a4.82,4.82,0,0,0-5.39.17C969.342,160.39,969.152,160.85,969.312,161.07Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6320",
    "data-name": "Path 6320",
    d: "M959.882,140.58a4.752,4.752,0,0,1,1.75-4.25,3.39,3.39,0,0,1,4.37.33,3.93,3.93,0,0,1,2.966-4.7,3.668,3.668,0,0,1,.4-.07c2.1-.13,3.89,1.45,5.92,2a9.593,9.593,0,0,0,6-.69c1.91-.77,3.69-1.83,5.61-2.53a16.44,16.44,0,0,1,21,9.66c2.81-.88,6,.55,7.75,2.93a12,12,0,0,1,1.83,8.44,26.284,26.284,0,0,1-1.47,5.77v.49c-.13,7.08-.93,15.38-4,15.43-5.26.08-4-9.83-4-9.83-6.46-2.49-4.05-12.16-5.67-13.63s-5-4.88-18.5,2c-5.25,2.68-12.23,2.6-16,1.73l-.34-.06h-.08l-.11-.05a11.892,11.892,0,0,1-3.47-1.47,6.843,6.843,0,0,1-2.85-3.17,3.742,3.742,0,0,1,.74-4A8.242,8.242,0,0,1,959.882,140.58Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6321",
    "data-name": "Path 6321",
    d: "M980.852,191.39a6,6,0,0,0,2.27-.28,3.3,3.3,0,0,0,1.71-1.55,3.44,3.44,0,0,0,0-2.78,2.806,2.806,0,0,0-.37-.63c-.17-.18-.13-.17-.32-.15a3.543,3.543,0,0,0-.68.27l-.69.29c-.91.36-1.73.68-2.43.94a7.664,7.664,0,0,1-2.31.7,7.671,7.671,0,0,1,2.1-1.19l2.36-1.1.69-.3a5.231,5.231,0,0,1,.77-.32.922.922,0,0,1,.63,0,1.143,1.143,0,0,1,.47.36,3.889,3.889,0,0,1,.35,4.2,3.661,3.661,0,0,1-2.16,1.75,3.519,3.519,0,0,1-1.83.07C981.032,191.58,980.842,191.43,980.852,191.39Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6322",
    "data-name": "Path 6322",
    d: "M1002.872,148.74a8.133,8.133,0,0,0,0-1.56,6.077,6.077,0,0,0-2-3.61,8.182,8.182,0,0,0-5.79-1.91,25.2,25.2,0,0,0-7.52,1.68,40.13,40.13,0,0,1-3.89,1.13,20.163,20.163,0,0,1-10.1-.38,19.8,19.8,0,0,1-4-1.68,11.6,11.6,0,0,1-1-.61,1.319,1.319,0,0,1-.33-.25s.49.28,1.39.73a21.636,21.636,0,0,0,4,1.56,20.93,20.93,0,0,0,6.25.74,20.2,20.2,0,0,0,3.69-.47c1.27-.29,2.55-.7,3.86-1.13a24.807,24.807,0,0,1,7.64-1.67,8.382,8.382,0,0,1,6,2.06,6.076,6.076,0,0,1,2,3.8A3.441,3.441,0,0,1,1002.872,148.74Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6323",
    "data-name": "Path 6323",
    d: "M1012.872,170.48a1.376,1.376,0,0,1-.17-.27c-.1-.18-.24-.46-.4-.82a16.843,16.843,0,0,1-1-3.2,17.2,17.2,0,0,1-.33-5,43.243,43.243,0,0,1,1.14-6,11.584,11.584,0,0,0,0-5.91,5.854,5.854,0,0,0-1.23-2.24,4.466,4.466,0,0,0-1.85-1.21,4.23,4.23,0,0,0-3.17.08,5.719,5.719,0,0,0-1,.69,2.487,2.487,0,0,1,.92-.82,4.289,4.289,0,0,1,3.33-.21,4.68,4.68,0,0,1,2,1.26,6.236,6.236,0,0,1,1.34,2.35,11.841,11.841,0,0,1,0,6.09,50.435,50.435,0,0,0-1.17,5.93,18.02,18.02,0,0,0,.25,4.89,18.7,18.7,0,0,0,.9,3.19C1012.712,170.07,1012.9,170.46,1012.872,170.48Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6324",
    "data-name": "Path 6324",
    d: "M1004.1,147.7a3.007,3.007,0,0,1,0-.52v-1.47a16.8,16.8,0,0,0-.59-5.34,9.4,9.4,0,0,0-1.72-3.25,6.65,6.65,0,0,0-3.45-2.28,8.722,8.722,0,0,0-4.6.19,21.678,21.678,0,0,0-4.6,2.09,37.824,37.824,0,0,1-4.57,2.35,13.955,13.955,0,0,1-4.7.94,14.524,14.524,0,0,1-4.31-.53,16.382,16.382,0,0,1-3.49-1.44,14.112,14.112,0,0,1-4.14-3.53,9.019,9.019,0,0,1-.84-1.22,2.64,2.64,0,0,1-.25-.45,2.1,2.1,0,0,1,.31.41,11.374,11.374,0,0,0,.89,1.17,14.914,14.914,0,0,0,4.16,3.39,16.635,16.635,0,0,0,3.44,1.37,14.336,14.336,0,0,0,4.22.48,13.72,13.72,0,0,0,4.58-.94,38.767,38.767,0,0,0,4.51-2.33,21.348,21.348,0,0,1,4.69-2.11,9,9,0,0,1,4.79-.17,7,7,0,0,1,3.61,2.41,9.92,9.92,0,0,1,1.73,3.37,16.237,16.237,0,0,1,.48,5.43,13.066,13.066,0,0,1-.12,1.47A1.747,1.747,0,0,1,1004.1,147.7Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6325",
    "data-name": "Path 6325",
    d: "M1017.942,216.67s30.71,9.81,32.71,15.13c1.53,4,17.65,52.36,21.12,83.89a23.15,23.15,0,0,1-20.594,25.451c-.135.014-.27.027-.406.039-20.77,1.91-50.92,4.39-50.92,2.68V317.71l39.11-5.71-14.47-42.53Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6326",
    "data-name": "Path 6326",
    d: "M978.582,338.58c4,1,21.32,1,21.32,1V319.07s-7.54-3.21-9.62-5.09-8-12.91-8-12.91a5.91,5.91,0,0,0-2.72,6.32c1,4.51,2.84,5.06,3,6.85,0,0,.16.47.16.49.41,2.5-2,4.71-2,4.71a8.612,8.612,0,0,0-2.63-1.35c-3.64-.43-8,2.18-8,3.64,0,0-.12,3.93,0,4.52s2,1.36,2,1.36-.58,2.62,0,3.79a6.231,6.231,0,0,0,2.53,2S976.322,338,978.582,338.58Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#fff",
    stroke: "#25292b",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6327",
    "data-name": "Path 6327",
    d: "M982.782,335.28a12.91,12.91,0,0,1-8.06-1.76c.06-.14,1.78.55,4,1S982.782,335.13,982.782,335.28Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6328",
    "data-name": "Path 6328",
    d: "M981.762,329.13a10.138,10.138,0,0,1-4.73.25,9.912,9.912,0,0,1-4.49-1.49c.06-.14,2,.64,4.56,1S981.742,329,981.762,329.13Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6329",
    "data-name": "Path 6329",
    d: "M981.162,311.49a7.739,7.739,0,0,1,1.39,2.51,9.044,9.044,0,0,1,.45,1.42,3.46,3.46,0,0,1,0,1.75,5.22,5.22,0,0,1-2.48,3,6.437,6.437,0,0,1-1.91.75,10.5,10.5,0,0,1-1.88.19c-1.18,0-2.24,0-3.12.05-1.77,0-2.83.26-2.86.19a7.155,7.155,0,0,1,2.84-.56c.89-.07,2-.09,3.12-.16a11.213,11.213,0,0,0,1.79-.21,6.107,6.107,0,0,0,1.76-.7,4.873,4.873,0,0,0,2.28-2.72,3,3,0,0,0,0-1.54,9.4,9.4,0,0,0-.36-1.37C981.652,312.49,981.092,311.53,981.162,311.49Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#25292b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6330",
    "data-name": "Path 6330",
    d: "M1039.442,311.88a9.729,9.729,0,0,1-1.54.33l-4.22.72c-3.57.59-8.5,1.37-14,2.2s-10.41,1.53-14,2-5.82.71-5.82.57l1.54-.26,4.23-.68,14-2.16c5.46-.82,10.4-1.55,14-2l4.24-.56A8.363,8.363,0,0,1,1039.442,311.88Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6331",
    "data-name": "Path 6331",
    d: "M1056.032,308a19.078,19.078,0,0,1-3.08,0c-1.9-.08-4.52-.23-7.41-.43a14.331,14.331,0,0,0-4,.05,4,4,0,0,0-2.6,1.65,2.831,2.831,0,0,0-.37,2.05c.12.49.31.73.27.76s-.27-.18-.46-.71a2.88,2.88,0,0,1,.24-2.29,4.33,4.33,0,0,1,2.81-1.93,13.883,13.883,0,0,1,4.14-.1c2.9.2,5.51.41,7.4.58A18.518,18.518,0,0,1,1056.032,308Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6332",
    "data-name": "Path 6332",
    d: "M1049.652,315.17a30.681,30.681,0,0,1-5.57-1.37,31.741,31.741,0,0,1-5.42-1.88,32.342,32.342,0,0,1,5.57,1.38A33.348,33.348,0,0,1,1049.652,315.17Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6333",
    "data-name": "Path 6333",
    d: "M1025.372,264c.13,0,3.28,9.9,7,22.21s6.68,22.32,6.54,22.36-3.29-9.9-7-22.21S1025.232,264.05,1025.372,264Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6334",
    "data-name": "Path 6334",
    d: "M1048.272,232.54c0,.1-1.8.37-4.53,1.43a27,27,0,0,0-15.61,15.71c-1,2.74-1.29,4.56-1.39,4.54a5.036,5.036,0,0,1,.15-1.27,22.441,22.441,0,0,1,.9-3.39,25.842,25.842,0,0,1,15.86-15.94,23.264,23.264,0,0,1,3.38-.92A5.518,5.518,0,0,1,1048.272,232.54Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6335",
    "data-name": "Path 6335",
    d: "M946.192,253.87a6.329,6.329,0,0,1,.06.7c0,.51,0,1.17.06,2,0,1.79.09,4.28.15,7.33.08,6.25.18,14.78.29,24.2s.11,18,.15,24.19v9.33a2.843,2.843,0,0,1,0,.69,3.193,3.193,0,0,1-.06-.69c0-.51,0-1.17-.06-2,0-1.8-.09-4.29-.15-7.34-.08-6.24-.18-14.77-.3-24.19s-.1-17.95-.14-24.2v-9.33A2.945,2.945,0,0,1,946.192,253.87Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6336",
    "data-name": "Path 6336",
    d: "M994.542,467.08a4.42,4.42,0,0,1-.21-.75c-.12-.55-.28-1.27-.49-2.17-.42-1.89-1-4.63-1.68-8-1.36-6.78-3.11-16.17-4.77-26.59s-2.93-19.89-3.75-26.76c-.41-3.43-.71-6.21-.9-8.13l-.21-2.22a3.91,3.91,0,0,1,0-.78,6.932,6.932,0,0,1,.14.77c.07.55.17,1.28.3,2.2.26,2,.62,4.73,1.07,8.12.91,6.85,2.23,16.31,3.89,26.72s3.35,19.81,4.62,26.6c.64,3.36,1.15,6.09,1.52,8.05.16.91.3,1.64.4,2.19A4.274,4.274,0,0,1,994.542,467.08Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6337",
    "data-name": "Path 6337",
    d: "M1050.822,341.18c0,.14-11.27,1-25.19,1.92s-25.2,1.55-25.21,1.4,11.26-1,25.18-1.92S1050.812,341,1050.822,341.18Z",
    transform: "translate(1891.14 10754.9)",
    fill: "#455a64"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart3);
export default __webpack_public_path__ + "static/media/start3.58006bb128750676bde1790cfec87018.svg";
export { ForwardRef as ReactComponent };